<template>
  <div class="w-full h-full bg-primary2">
    <Navigation />
    <div
      class="relative flex w-full h-full maxwidthscreen mx-auto"
      style="min-height: calc(100vh - 80px)"
    >
      <LeftNavigation />
      <div class="mx-auto h-full" style="width: calc(100vw - 60px)">
        <div class="h-full lg:p-4">
          <!-- Select Options -->
          <div class="mt-10 hidden lg:block">
            <ul
              class="flex justify-evenly items-center border lg:text-sm xl:text-lg border-gray-200 shadow-lg rounded-t-2xl font-medium cursor-pointer"
            >
              <li
                class="lg:p-3 xl:p-4 border-r w-[20%] relative rounded-tl-2xl"
                @click="this.selectOption = 'summary'"
                :class="[
                  this.selectOption == 'summary'
                    ? 'bg-primary text  selectOptions'
                    : '',
                ]"
              >
                Summary
              </li>
              <li
                class="lg:p-3 xl:p-4 border-r w-[20%] relative"
                @click="
                  this.selectOption = 'Leads_details';
                  commingSoon = false;
                "
                :class="[
                  this.selectOption == 'Leads_details'
                    ? 'bg-primary text selectOptions'
                    : '',
                ]"
              >
                Leads
              </li>
              <li
                class="lg:p-3 xl:p-4 border-r w-[20%] relative"
                @click="this.selectOption = 'campaign'"
                :class="[
                  this.selectOption == 'campaign'
                    ? 'bg-primary text selectOptions'
                    : '',
                ]"
              >
                Campaigns
              </li>
              <li
                class="lg:p-3 xl:p-4 border-r w-[20%] relative"
                @click="this.selectOption = 'student'"
                :class="[
                  this.selectOption == 'student'
                    ? 'bg-primary text selectOptions'
                    : '',
                ]"
              >
                Students
              </li>
              <li
                class="lg:p-3 xl:p-4 border-r w-[20%] relative"
                @click="this.selectOption = 'campaign-maping'"
                :class="[
                  this.selectOption == 'campaign-maping'
                    ? 'bg-primary text selectOptions'
                    : '',
                ]"
              >
                Mappings
              </li>
              <li
                class="lg:p-3 xl:p-4 border-r w-[20%] relative rounded-tr-2xl"
                @click="this.selectOption = 'email'"
                :class="[
                  this.selectOption == 'email'
                    ? 'bg-primary text selectOptions'
                    : '',
                ]"
              >
                Email Templates
              </li>
            </ul>
          </div>
          <!-- mobile -->
          <div class="mt-10 block lg:hidden">
            <select
              v-model="selectOption"
              class="w-full p-4 border rounded-lg shadow-lg"
            >
              <option value="summary">Summary</option>
              <option value="Leads_details">Leads</option>
              <option value="campaign">Campaign</option>
              <option value="student">Student</option>
              <option value="campaign-maping">Mapping</option>
              <option value="email">Email Template</option>
            </select>
          </div>
          <Transition>
            <div
              v-if="this.is_popup == true"
              class="fixed z-50 bg-primary2 min-h-screen w-full top-0 left-0 bg-opacity-90 flex justify-center items-center"
            >
              <div
                class="max-w-2xl w-full border h-[320px] rounded-md shadow-lg flex flex-col items-start justify-center p-10 bg-primary2 relative input-border"
              >
                <div
                  class="absolute top-4 right-4 cursor-pointer"
                  @click="this.is_popup = false"
                >
                  <img :src="close" alt="" class="h-6" />
                </div>
                <form
                  ref="fileUploadFiled"
                  @submit.prevent="fileUpload"
                  class="flex flex-col gap-5 items-start w-full"
                >
                  <div class="flex flex-col items-start w-[80%] gap-2">
                    <label
                      for="batch_name"
                      class="bulkUpload text-base font-medium"
                      >Batch Name</label
                    >
                    <input
                      type="text"
                      id="batch_name"
                      class="border input-border w-full rounded-md h-7 focus:border-0 focus:ring-[#FEC520]"
                      required
                    />
                  </div>
                  <div class="flex flex-col items-start gap-2">
                    <label
                      for="fileUpload_csv"
                      class="bulkUpload text-base font-medium"
                      >File Upload
                    </label>
                    <input
                      type="file"
                      id="fileUpload_csv"
                      class="border w-full rounded-md"
                      accept=".csv"
                      required
                    />
                    <div class="flex gap-2">
                      <p class="text-xs text-gray-400">
                        Input field format with sample data
                      </p>
                      <a
                        href="https://api.lots.learn.online/media/lesson_mdfile/student_example.csv"
                        target="_blank"
                      >
                        <img
                          :src="download"
                          alt="download"
                          class="h-5 cursor-pointer"
                        />
                      </a>
                    </div>
                  </div>
                  <div class="flex gap-4 items-center">
                    <button
                      v-if="this.ld_btn != true"
                      class="border px-2 py-1 text-sm font-medium rounded-md btn"
                      type="submit"
                    >
                      Submit
                    </button>
                    <button
                      v-else
                      class="border px-2 py-1 text-sm rounded-md btn"
                    >
                      Loading..
                    </button>
                    <div v-if="this.message.text != ''">
                      <p
                        class="text-sm font-medium text"
                        :class="
                          this.message.type == 'error'
                            ? ' text-red-600'
                            : ' text-green-700'
                        "
                      >
                        {{ this.message.text }}
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Transition>
          <!-- summary start -->
          <div v-if="selectOption == 'summary'">
            <div
              v-if="this.userCountVal.isData"
              class="flex flex-col w-full px-2 mt-10 items-center border border-b-0 bg-primary2 py-6 rounded-t-md shadow-md"
            >
              <circleChart
                :chart1="this.userCountVal.allUser"
                :chart2="this.userCountVal.allUserVerified"
                :chart3="this.userCountVal.exams_done"
                :chart4="this.userCountVal.students_applied_elective"
                :chart5="this.userCountVal.enrollment"
                :chart6="this.userCountVal.downloadbrochure"
              />
            </div>

            <div v-else class="" style="height: calc(100vh - 80px)">
              <div class="flex flex-col justify-center items-center h-full">
                <img
                  :src="no_data"
                  class="w-full h-[500px] object-contain"
                  alt=""
                  srcset=""
                />
                <h1 class="text-black text-lg">NO DATA FOUND</h1>
              </div>
            </div>
          </div>
          <!-- summary end  -->
          <!-- Leads start -->
          <div
            v-if="selectOption == 'Leads_details' && commingSoon == false"
            class="maxwidthscreen containerHead bg-primary2 mt-5 lg:mt-10 rounded-md"
            style="height: calc(100vh - 80px)"
          >
            <div v-if="loader == false">
              <div
                class="flex justify-start lg:justify-end items-center py-2 lg:p-4"
              >
                <form @submit.prevent="searchLead" class="flex gap-2 lg:gap-4">
                  <input
                    type="text"
                    name="lead_search"
                    id="lead_search"
                    v-model="lead_search"
                    placeholder="Search by name"
                    class="rounded-lg w-[80%] lg:w-[240px]"
                  />
                  <button
                    type="submit"
                    class="btn text-sm px-4 py-2 rounded-lg"
                  >
                    Search
                  </button>
                </form>
              </div>
              <div
                v-if="this.leads.length > 0"
                class="overflow-scroll border border-t-0 shadow-md text-start"
              >
                <table class="min-w-full bg-primary2">
                  <thead
                    class="bg-primary border-b text-start sticky top-0 text"
                  >
                    <tr class="">
                      <th
                        scope="col"
                        class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                      >
                        S.No
                      </th>
                      <th
                        scope="col"
                        class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                      >
                        Email
                      </th>
                      <th
                        scope="col"
                        class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                      >
                        Phone
                      </th>
                      <th
                        scope="col"
                        class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                      >
                        College Name
                      </th>
                      <th
                        scope="col"
                        class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                      >
                        Stage
                      </th>
                      <!-- <th
                    scope="col"
                    class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                  >
                    Interest Product
                  </th> -->
                      <th
                        scope="col"
                        class="text-start text-base font-medium px-4 py-2 xl:px-6 xl:py-4"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(el, index) in this.leads"
                      :key="index"
                      class="border-b"
                    >
                      <td
                        class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                      >
                        {{ index + (this.current_page_number - 1) * 20 + 1 }}
                      </td>
                      <td
                        class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                      >
                        {{ el.name }}
                      </td>
                      <td
                        class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                      >
                        {{ el.email }}
                      </td>
                      <td
                        class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                      >
                        <div v-if="el.phone_number">
                          {{ el.phone_number }}
                        </div>
                        <div v-else>Null</div>
                      </td>
                      <td
                        class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                      >
                        <div v-if="el.university_list">
                          {{ el.university_list }}
                        </div>
                        <div v-else>Null</div>
                      </td>
                      <td
                        class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                      >
                        <div v-if="el.stage">
                          {{ el.stage }}
                        </div>
                        <div v-else>Null</div>
                      </td>
                      <!-- <td
                    class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                  >
                    <div v-if="el.lead_pri_product">
                      {{ el.lead_pri_product.name }}
                    </div>
                    <div v-else>Null</div>
                  </td> -->
                      <td
                        class="text-sm text-gray-900 font-normal px-4 py-2 xl:px-6 xl:py-4 whitespace-nowrap"
                      >
                        <!-- <router-link
                          :to="{
                            name: 'lead_detail',
                            params: { id: el.id },
                          }"
                        >
                          <button
                            class="cursor-pointer text-[#2563EB] hover:underline"
                          >
                            View
                          </button>
                    </router-link> -->
                        <button
                          @click="fetchLeadDetail(el.id)"
                          class="cursor-pointer text-[#2563EB] hover:underline"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot class="bg-primary border-b text">
                    <tr class="">
                      <td colspan="7" class="px-4 py-2 xl:px-6 xl:py-4">
                        <div class="w-full flex justify-between items-center">
                          <h2 class="">
                            Showing {{ first_value }} to
                            {{ last_value }}
                          </h2>
                          <h2 class="">
                            Page {{ total_std_list.current_page_number }} of
                            {{ total_std_list.total_pages }}
                          </h2>
                          <div class="flex gap-4">
                            <button
                              v-if="lead_prev"
                              @click="prevLead"
                              class="btn px-2 py-1 rounded-md"
                            >
                              prev
                            </button>
                            <button
                              v-if="lead_next"
                              @click="nextLead"
                              class="btn px-2 py-1 rounded-md"
                            >
                              next
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div v-else class="" style="height: calc(100vh - 80px)">
                <div class="flex flex-col justify-center items-center h-full">
                  <img
                    :src="no_data"
                    class="w-full h-[500px] object-contain"
                    alt=""
                    srcset=""
                  />
                  <h1 class="text-black text-lg">NO DATA FOUND</h1>
                </div>
              </div>
            </div>
            <div
              v-if="loader"
              class="flex flex-col justify-center items-center"
            >
              <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              Loading...
            </div>
          </div>
          <!-- Leads end -->
          <!-- Campaign start -->
          <div
            v-if="selectOption == 'campaign'"
            class="!w-full !h-full"
            style="height: calc(100vh - 300px)"
          >
            <CampaignView />
          </div>
          <!-- Campaign end -->
          <!-- student list start  -->
          <div
            v-if="selectOption == 'student'"
            class="bg-primary2 w-full h-full flex justify-center items-center"
            style="height: calc(100vh - 300px)"
          >
            <RecipientViewVue />
            <!-- <div
              class="w-full lg:w-[500px] h-[300px] lg:h-[500px] flex justify-center items-center"
            >
              <img
                src="@/assets/df-23.webp"
                alt="coming soon image"
                class="object-contain rounded-xl"
              />
            </div> -->
          </div>
          <!-- student list end  -->
          <!-- campaign-maping start -->
          <div
            v-if="selectOption == 'campaign-maping'"
            class="bg-primary2 w-full h-full flex justify-center items-center"
            style="height: calc(100vh - 300px)"
          >
            <CampaignMapping />
          </div>
          <!-- campaign-maping end  -->
          <!-- campaign-maping start -->
          <div
            v-if="selectOption == 'email'"
            class="bg-primary2 w-full h-full flex justify-center items-center"
            style="height: calc(100vh - 300px)"
          >
            <EmailTemplate />
          </div>
          <!-- campaign-maping end  -->
          <div
            v-if="selectOption == 'Leads_details' && commingSoon == true"
            class="bg-primary2"
            style="height: calc(100vh - 100px)"
          >
            <div class="flex maxwidthscreen mx-auto">
              <div class="w-full pb-3">
                <div class="flex justify-between py-5 w-full">
                  <h1 class="text-2xl font-semibold">Lead Details</h1>
                  <div class="flex gap-2 lg;gap-5">
                    <button
                      class="btn text px-4 py-2 rounded-lg"
                      @click="
                        selectOption == 'Leads_details';
                        commingSoon = false;
                      "
                    >
                      Back
                    </button>
                    <button
                      class="btn text px-4 py-2 rounded-lg"
                      @click="openOffcanvas"
                    >
                      Update
                    </button>
                  </div>
                </div>

                <!-- Offcanvas -->
                <div
                  v-if="showOffcanvas"
                  class="z-50 flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
                >
                  <div
                    class="bg-white p-6 flex flex-col justify-center items-center w-full lg:w-[500px] rounded-xl relative !z-999"
                  >
                    <div class="flex justify-between items-center mb-4 w-full">
                      <h2 class="text-xl font-semibold">
                        Update Lead Owner
                      </h2>

                      <span
                        @click="closeOffcanvas"
                        class="font-semibold text-lg hover:text-red-700 cursor-pointer"
                        >x</span
                      >
                    </div>
                    <form
                      action=""
                      @submit.prevent=""
                      class="p-4 flex flex-col gap-4 h-[80%] w-full rounded-lg overflow-y-scroll"
                    >
                      <div class="flex flex-col text-start">
                        <label for="updatedSource">Lead Owner Name</label>
                        <input
                          v-model="poc_name"
                          id="updatedSource"
                          type="text"
                          class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
                        />
                      </div>
                      <div class="flex flex-col text-start">
                        <label for="updatedSource">Lead Owner Email</label>
                        <input
                          v-model="poc_email"
                          id="updatedSource"
                          type="email"
                          class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
                        />
                      </div>
                      <div class="flex flex-col text-start">
                        <label for="updatedSource">Lead Owner Phone</label>
                        <div class="flex w-full">
                          <select
                            v-model="selectedCountryCodePoc"
                            class="w-20 px-3 py-2 text-sm font-normal text-input bg-primary2 bg-clip-padding focus:ring-0 focus:border-primary border-[#e5e7eb] rounded mb-3 shadow-md focus:outline-none"
                          >
                            <option
                              v-for="country in countryCodes"
                              :key="country.code"
                              :value="country.code"
                            >
                              {{
                                selectedCountryCodePoc === country.code
                                  ? country.code
                                  : `${country.name} (${country.code})`
                              }}
                            </option>
                          </select>
                          <input
                            type="tel"
                            name="mobile"
                            id="Mobile"
                            autocomplete="off"
                            maxlength="10"
                            pattern="[0-9]*"
                            placeholder="mobile *"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                            v-model="poc_phone"
                            class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
                          />
                        </div>
                      </div>

                      <div class="flex flex-col text-start">
                        <label for="updatedSource">Lead Owner Role</label>
                        <input
                          v-model="poc_role"
                          id="updatedSource"
                          type="text"
                          class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
                        />
                      </div>
                      <div class="flex justify-center pt-3">
                        <button
                          type="submit"
                          class="py-2 w-40 rounded-lg bg-primary1 text cursor-not-allowed"
                        >
                          Update
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <!-- lead stage start -->
                <div
                  v-if="editLeadSatge"
                  class="z-50 flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
                >
                  <div
                    class="bg-white p-6 flex flex-col justify-center items-center w-full lg:w-[800px] rounded-xl relative !z-999"
                  >
                    <div class="flex justify-between items-center mb-4 w-full">
                      <h2 class="text-xl font-semibold">Update Lead Stage</h2>

                      <span
                        @click="editLeadSatge = false"
                        class="font-semibold text-lg hover:text-red-700 cursor-pointer"
                        >x</span
                      >
                    </div>
                    <form
                      action=""
                      @submit.prevent=""
                      class="p-4 flex flex-col gap-4 h-[80%] w-full rounded-lg overflow-y-scroll"
                    >
                      <div class="flex flex-col text-start">
                        <label for="selected_stage">Lead Stage</label>
                        <select
                          name="selected_stage"
                          id="selected_stage"
                          required
                          v-model="selected_stage"
                          class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
                        >
                          <option value="" selected disabled>
                            Select Lead Stage
                          </option>
                          <option
                            v-for="el in lead_stage"
                            :key="el"
                            :value="el"
                          >
                            {{ el }}
                          </option>
                        </select>
                      </div>

                      <div class="flex flex-col text-start">
                        <label for="selected_sub_stage">Lead Sub Stage</label>
                        <select
                          name="selected_sub_stage"
                          id="selected_sub_stage"
                          required
                          v-model="selected_sub_stage"
                          class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
                        >
                          <option value="" selected disabled>
                            Select Lead Sub Stage
                          </option>
                          <option v-for="el in sub_stage" :key="el" :value="el">
                            {{ el }}
                          </option>
                        </select>
                      </div>
                      <div class="flex flex-col text-start">
                        <label for="callback_date">Callback Date</label>
                        <input
                          v-model="callback_date"
                          id="callback_date"
                          type="date"
                          class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
                        />
                      </div>
                      <div class="flex flex-col text-start">
                        <label for="callback_time">Callback Time</label>
                        <input
                          v-model="callback_time"
                          id="callback_time"
                          type="time"
                          class="border input-border rounded-md h-8 md:h-10 w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
                        />
                      </div>
                      <div class="flex flex-col text-start">
                        <label for="lead_comment">Comment</label>
                        <textarea
                          name=""
                          id="lead_comment"
                          cols="30"
                          v-model="lead_comment"
                          rows="6"
                          class="border input-border rounded-md w-full text-sm md:text-base pr-6 focus:outline-none focus:border-0 focus:ring-1"
                        ></textarea>
                      </div>

                      <div class="flex justify-end pt-3">
                        <button
                          type="submit"
                          class="py-2 w-40 rounded-lg bg-primary1 text cursor-not-allowed"
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                <!-- lead details -->

                <div class="lg:flex gap-x-10 items-center bg-primary2">
                  <div
                    v-if="lead_details"
                    class="md:w-[35%] p-5 h-80 border rounded-lg text bg-primary"
                  >
                    <div v-for="lead in lead_details" :key="lead">
                      <div class="flex justify-between items-center py-2">
                        <div class="flex items-center gap-1">
                          <p class="border rounded-md px-2 p-1">D</p>
                          <div class="flex flex-col gap-2 px-2">
                            <p class="font-semibold text-left">
                              <span v-if="lead.name">{{
                                lead.name
                              }}</span>
                              <span v-else>Null</span>
                            </p>
                            <p
                              class="text-sm bg-primary flex gap-2 items-center cursor-pointer"
                              @click="editLeadSatge = true"
                            >
                              Untouched
                              <span
                                ><img
                                  :src="edit"
                                  class="w-6 h-6 object-contain"
                              /></span>
                            </p>
                          </div>
                        </div>
                        <button class="border px-2 h-8 rounded-lg">
                          {{ lead.id }}
                        </button>
                      </div>
                      <table cellpadding="5" class="text-start">
                        <tbody class="text-sm">
                          <tr>
                            <td class="font-semibold">Email</td>
                            <td class="px-2">:</td>
                            <td class="">
                              <span v-if="lead.email">{{ lead.email }}</span>
                              <span v-else>Null</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="font-semibold">Mobile</td>
                            <td class="px-2">:</td>
                            <td>
                              <span v-if="lead.phone_number">{{
                                lead.phone_number
                              }}</span>
                              <span v-else>Null</span>
                            </td>
                          </tr>
                          <tr>
                            <td class="font-semibold">Created at</td>
                            <td class="px-2">:</td>
                            <td>{{ formatDate(lead.created_at) }}</td>
                          </tr>
                          <tr>
                            <td class="font-semibold whitespace-nowrap">
                              Last Update
                            </td>
                            <td class="px-2">:</td>
                            <td>{{ formatDate(lead.updated_at) }}</td>
                          </tr>
                          <tr>
                            <td class="font-semibold">Country</td>
                            <td class="px-2">:</td>
                            <td>India</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div
                    class="md:w-[65%] h-80 flex items-center rounded-lg p-5 justify-evenly border text bg-primary"
                  >
                    <div
                      class="w-[50%]"
                      v-for="lead in lead_details"
                      :key="lead"
                    >
                      <h3 class="text text-2xl text-left py-2">Lead Owner</h3>
                      <table cellpadding="5" class="text-start">
                        <tbody class="text-sm">
                          <tr class="py-1">
                            <td class="font-semibold">Name</td>
                            <td class="px-2">:</td>
                            <td>Null</td>
                          </tr>
                          <tr class="py-1">
                            <td class="font-semibold">Email</td>
                            <td class="px-2">:</td>
                            <td>Null</td>
                          </tr>
                          <tr class="py-1">
                            <td class="font-semibold">Phone</td>
                            <td class="px-2">:</td>
                            <td>Null</td>
                          </tr>
                          <tr class="py-1">
                            <td class="font-semibold">Role</td>
                            <td class="px-2">:</td>
                            <td>Null</td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="flex flex-col gap-2 pt-1">
                        <p class="text-left">Assigned @ Name</p>
                        <p class="text-left">
                          Lead Source :
                          {{ lead.utm_source }}
                        </p>
                      </div>
                    </div>
                    <div class="grid grid-cols-2 gap-6 w-[50%]">
                      <div class="py-5 border rounded-lg">
                        <!-- <p>1</p> -->
                        <p>Email</p>
                      </div>
                      <div class="py-5 border rounded-lg">
                        <!-- <p>1</p> -->
                        <p>SMS</p>
                      </div>
                      <div class="py-5 border rounded-lg">
                        <!-- <p>1</p> -->
                        <p>Whatsapp</p>
                      </div>
                      <div class="py-5 border rounded-lg">
                        <!-- <p>1</p> -->
                        <p>Call</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Side Nav -->
                <div class="text-start pt-5 flex gap-5">
                  <ul class="flex md:flex-col w-[20%] h-96">
                    <li
                      @click="setActiveComponent('LeadInfo')"
                      class="text-md font-semibold cursor-pointer p-2 flex items-center"
                      :class="[
                        activeComponent === 'LeadInfo'
                          ? 'bg-primary text'
                          : 'text-black bg-primary2',
                      ]"
                    >
                      <p>Lead Details</p>
                    </li>
                    <li
                      @click="setActiveComponent('FollowNote')"
                      class="text-md font-semibold cursor-pointer border-b p-2 flex items-center"
                      :class="[
                        activeComponent === 'FollowNote'
                          ? 'bg-primary text'
                          : 'text-black bg-primary2',
                      ]"
                    >
                      <p>Followup Notes</p>
                    </li>
                    <li
                      @click="setActiveComponent('TimeLine')"
                      class="text-md font-semibold cursor-pointer border-b p-2 flex items-center"
                      :class="[
                        activeComponent === 'TimeLine'
                          ? 'bg-primary text'
                          : 'text-black bg-primary2',
                      ]"
                    >
                      <p>Time Line</p>
                    </li>
                  </ul>

                  <!-- Tabs Section -->
                  <div class="w-full h-96">
                    <div
                      v-if="activeComponent === 'LeadInfo'"
                      class="p-5 overflow-y-auto 2xl:overflow-hidden"
                    >
                      <p class="border-b">Lead More Info</p>
                      <table
                        class="mt-5 text-left"
                        v-for="lead in lead_details"
                        :key="lead"
                      >
                        <tbody>
                          <tr>
                            <td class="font-semibold whitespace-nowrap">
                              Highest Qualification
                            </td>
                            <td class="px-2">:</td>
                            <td class="px-5 py-2">
                              <span v-if="lead.highest_qualification">
                                {{ lead.highest_qualification.name }}
                              </span>
                              <sapn v-else>Null</sapn>
                            </td>
                          </tr>
                          <tr>
                            <td class="font-semibold">University</td>
                            <td class="px-2">:</td>
                            <td class="px-5 py-2">
                              <span v-if="lead.university_list">{{
                                lead.university_list
                              }}</span>
                              <sapn v-else>Null</sapn>
                            </td>
                          </tr>
                          <tr>
                            <td class="font-semibold">Program</td>
                            <td class="px-2">:</td>
                            <td class="px-5 py-2">
                              <span v-if="lead.program">{{
                                lead.program.name
                              }}</span>
                              <sapn v-else>Null</sapn>
                            </td>
                          </tr>
                          <tr>
                            <td class="font-semibold">Elective</td>
                            <td class="px-2">:</td>
                            <td class="px-5 py-2">
                              <span v-if="lead.elective">{{
                                lead.elective.name
                              }}</span>
                              <sapn v-else>Null</sapn>
                            </td>
                          </tr>
                          <tr>
                            <td class="font-semibold">Source</td>
                            <td class="px-2">:</td>
                            <td class="px-5 py-2">
                              <span v-if="lead.utm_source">{{
                                lead.utm_source
                              }}</span
                              ><sapn v-else>Null</sapn>
                            </td>
                          </tr>
                          <tr>
                            <td class="font-semibold">Medium</td>
                            <td class="px-2">:</td>
                            <td class="px-5 py-2">
                              <span v-if="lead.utm_medium">{{
                                lead.utm_medium
                              }}</span
                              ><sapn v-else>Null</sapn>
                            </td>
                          </tr>
                          <tr>
                            <td class="font-semibold">Campaign</td>
                            <td class="px-2">:</td>
                            <td class="px-5 py-2">
                              <span v-if="lead.utm_campaign">{{
                                lead.utm_campaign
                              }}</span
                              ><sapn v-else>Null</sapn>
                            </td>
                          </tr>
                          <tr>
                            <td class="font-semibold">Onboarded Date</td>
                            <td class="px-2">:</td>
                            <td class="px-5 py-2">
                              {{ formatDate(lead.created_at) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div
                      v-if="activeComponent === 'FollowNote'"
                      class="relative p-5 h-96"
                    >
                      <h1 class="text-center font-bold">Follow Note</h1>
                      <div
                        class="flex justify-end gap-3 p-5 absolute top-0 right-0"
                      >
                        <button
                          class="rounded-lg px-4 py-2 bg-primary text"
                          @click="toggleLeadEdit"
                        >
                          Lead Activity
                        </button>
                        <button
                          class="rounded-lg px-4 py-2 bg-primary text"
                          @click="toggleOffcanvas"
                        >
                          Add Note
                        </button>
                      </div>

                      <!-- Display Notes -->
                      <div class="flex flex-col gap-y-2">
                        <table
                          class="mt-5 text-left"
                          v-for="note in followup_list"
                          :key="note"
                        >
                          <tbody>
                            <tr>
                              <td class="font-semibold whitespace-nowrap">
                                Title
                              </td>
                              <td class="px-2">:</td>
                              <td class="px-5 py-2">
                                {{ note.title }}
                              </td>
                            </tr>
                            <tr>
                              <td class="font-semibold">University</td>
                              <td class="px-2">:</td>
                              <td class="px-5 py-2">{{ note.note }}</td>
                            </tr>
                            <tr>
                              <td class="font-semibold">Onboarded Date</td>
                              <td class="px-2">:</td>
                              <td class="px-5 py-2">
                                {{ formatDate(note.created_date) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- <div
                          class="flex flex-col gap-y-1"
                          v-for="note in followup_list"
                          :key="note.id"
                        >
                          <h1 class="font-semibold">{{ note.title }}</h1>
                          <p class="text-md">{{ note.note }}</p>
                          <p class="text-xs">
                            Created by {{ note.created_date }}
                          </p>
                          <hr />
                        </div> -->
                      </div>
                      <!-- followup notes  -->
                      <div
                        class="bg-primary text font-bold absolute top-0 right-0 border h-[380px] transform transition-transform duration-300 p-5 rounded-lg"
                        :class="{
                          '-translate-x-full hidden': !isOffcanvasOpen,
                          'translate-x-0': isOffcanvasOpen,
                        }"
                      >
                        <h1 class="text-center">Enter Note</h1>
                        <form @submit.prevent="submitFollowup" class="">
                          <div class="flex flex-col mb-4">
                            <label for="title" class="mb-1">Title</label>
                            <input
                              type="text"
                              class="border outline-none rounded-lg text-black font-medium px-3 py-1.5 bg-primary2"
                              name="title"
                              v-model="followup_title"
                              id="title"
                            />
                          </div>
                          <div class="flex flex-col">
                            <label for="note" class="mb-1">Note</label>
                            <textarea
                              :style="{ resize: 'none' }"
                              name="note"
                              id="note"
                              class="border outline-none rounded-lg text-black font-medium px-3 overflow-y-scroll bg-primary2"
                              cols="30"
                              rows="5"
                              v-model="followup_note"
                            ></textarea>
                          </div>
                          <div class="flex justify-between pt-5">
                            <button
                              type="submit"
                              class="px-4 py-2 rounded-lg bg-primary2 text-[#2563EB] cursor-pointer"
                            >
                              Save Note
                            </button>
                            <button
                              class="px-4 py-2 rounded-lg bg-primary2 text-[#2563EB]"
                              @click="closeOffNotes"
                            >
                              Close
                            </button>
                          </div>
                        </form>
                      </div>
                      <!-- lead activity form  -->
                      <div
                        class="bg-primary text font-bold absolute top-0 right-0 border h-[380px] overflow-y-scroll transform transition-transform duration-300 p-5 rounded-lg"
                        :class="{
                          '-translate-x-full hidden': !lead_activity_tog,
                          'translate-x-0': lead_activity_tog,
                        }"
                      >
                        <h1 class="text-center">Enter Lead Activity</h1>
                        <form @submit.prevent="leadActivity" class="">
                          <div class="flex flex-col mb-4">
                            <label for="title" class="mb-1">Lead Stage</label>
                            <select
                              name="selected_stage"
                              id="selected_stage"
                              required
                              v-model="lead_act_stage"
                              class="border outline-none rounded-lg text-black font-medium px-3 py-1.5 bg-primary2"
                            >
                              <option value="" selected disabled>
                                Select Lead Stage
                              </option>
                              <option
                                v-for="el in lead_stage"
                                :key="el"
                                :value="el"
                              >
                                {{ el }}
                              </option>
                            </select>
                          </div>
                          <div class="flex flex-col">
                            <label for="note" class="mb-1">Sub Stage</label>
                            <select
                              name="selected_sub_stage"
                              id="selected_sub_stage"
                              required
                              v-model="lead_act_sub_stage"
                              class="border outline-none rounded-lg text-black font-medium px-3 py-1.5 bg-primary2"
                            >
                              <option value="" selected disabled>
                                Select Lead Sub Stage
                              </option>
                              <option
                                v-for="el in sub_stage"
                                :key="el"
                                :value="el"
                              >
                                {{ el }}
                              </option>
                            </select>
                          </div>
                          <div class="flex flex-col mb-4">
                            <label for="date" class="mb-1">Date</label>
                            <input
                              type="date"
                              class="border outline-none rounded-lg text-black font-medium px-3 py-1.5 bg-primary2"
                              name="date"
                              v-model="lead_act_date"
                              id="date"
                            />
                          </div>
                          <div class="flex flex-col mb-4">
                            <label for="time" class="mb-1">Time</label>
                            <input
                              type="time"
                              class="border outline-none rounded-lg text-black font-medium px-3 py-1.5 bg-primary2"
                              name="time"
                              v-model="lead_act__time"
                              id="time"
                            />
                          </div>
                          <div class="flex flex-col">
                            <label for="note" class="mb-1">comment</label>
                            <textarea
                              :style="{ resize: 'none' }"
                              name="note"
                              id="note"
                              class="border outline-none rounded-lg text-black font-medium px-3 overflow-y-scroll bg-primary2"
                              cols="30"
                              rows="5"
                              v-model="lead_act_comment"
                            ></textarea>
                          </div>
                          <div class="flex justify-between pt-5">
                            <button
                              type="submit"
                              class="px-4 py-2 rounded-lg bg-primary2 text-[#2563EB] cursor-pointer"
                            >
                              Submit
                            </button>
                            <button
                              class="px-4 py-2 rounded-lg bg-primary2 text-[#2563EB]"
                              @click="lead_activity_tog = false"
                            >
                              Close
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div
                      v-if="activeComponent === 'TimeLine'"
                      class="p-5 overflow-y-auto 2xl:overflow-hidden"
                    >
                      <p class="border-b">Lead History</p>
                      <p class="text-xl">No Data</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navigation from "@/components/Navigation.vue";
import Chart from "chart.js/auto";
import axios from "axios";
import convertdate from "@/services/DateConvert.js";
import circleChart from "@/components/circleChart.vue";
import LeftNavigation from "@/components/LeftNavigationAdminView.vue";
import CampaignView from "@/components/Campaign/CampaignView.vue";
import { mapActions, mapGetters } from "vuex";
import stateMixins from "@/mixins/stateMixins";
import countryCodeMixins from "@/mixins/countryCodeMixins";
import CampaignMapping from "@/components/Campaign/CampaignMapping.vue";
import RecipientViewVue from "../../components/Campaign/RecipientView.vue";
import EmailTemplate from "../../components/Campaign/EmailTemplate.vue";
export default {
  name: "LeadDashboardView",
  data() {
    return {
      slice_limit: 10,
      total_pages: 0,
      slice_start: 0,
      slice_end: 0,
      current_position: 0,
      currentPage: 1,
      perPage: 15,
      university_list: [],
      program_list: [],
      elective_list: [],
      selectedProgram: "",
      selectedUser: "",
      queryVal: [],
      queryVal_qlf: "",
      dhoverall: {
        total_users: 200,
        total_result: 100,
        qualified_users: 10,
        all_user_users: 15,
      },
      select_val: "all_user",
      userRegisterList: "",
      selectUserStr: "",
      qualified_data: [],
      examsResultsList: "",
      userCountVal: {
        allUser: 0,
        allUserVerified: 0,
        exams_done: 0,
        students_applied_elective: 0,
        downloadbrochure: 0,
        enrollment: 0,
        isData: false,
      },
      is_popup: false,
      ld_btn: false,
      message: {
        text: "",
        type: "",
      },
      selectOption: "summary",
      filterList: false,
      checkboxFilter: [
        "name",
        "email",
        "university",
        "qualification",
        "state",
        "city",
        "contact",
        "source",
        "joined",
      ],
      checkboxFilterExam: ["name", "email", "mark", "scholarship", "coupon"],
      appliedElectiveList: [],
      fieldFilterapplyele: [
        "name",
        "email",
        "phone",
        "elective",
        "university",
        "date",
      ],
      downloadbrochure: [],
      fieldFilterdownload: [
        "name",
        "email",
        "phone",
        "elective",
        "university",
        "date",
      ],
      cpList: [],
      frontEnd: "",
      appliedUniversityList: [],
      commingSoon: false,
      leads: [],
      activeComponent: "LeadInfo",
      lead_details: [],
      showOffcanvas: false,
      statusList: [],
      platforms: [],
      selectedCountryCode: "+91",
      selectedCountryCodePoc: "+91",
      cities: [],
      isOffcanvasOpen: false,
      addCampain: false,
      followup_title: "",
      followup_note: "",
      lead_id: "",
      followup_list: [],
      close: require(`${process.env.VUE_APP_CLOSE}`),
      download: require(`${process.env.VUE_APP_DOWNLOAD}`),
      next: require(`${process.env.VUE_APP_NEXT}`),
      back: require(`${process.env.VUE_APP_BACK}`),
      no_data: require(`${process.env.VUE_APP_NODATA}`),
      edit: require(`${process.env.VUE_APP_WHITE_EDIT}`),
      loader: false,
      loaders: true,
      lead_search: "",
      total_std_list: "",
      lead_next: "",
      lead_prev: "",
      current_page_number: "",
      total_pages: "",
      first_value: 1,
      last_value: 20,
      editLeadSatge: false,
      lead_activity_tog: false,
      lead_stage: [
        "New",
        "No Response",
        "Cold",
        "Warm",
        "Hot",
        "Not Intereseted",
        "Invalid",
        "Old Leads",
        "Admission",
      ],
      sub_stage: [
        "Untouched",
        "RNR/Switch Off",
        "Callback",
        "Discussion",
        "Followup",
        "Application Filled",
        "Followup",
        "Payment Link Shared",
        "Followup",
        "Pending for Verification",
        "Completed Verification",
        "NI 1",
        "NI 2",
        "NI 3",
        "Application Rejected",
        "Wrong Number",
        "Language Barrier",
        "Others",
        "Enagagement",
        "Admission Completed",
        "ERP Activated",
        "ERP Pending",
      ],
      selected_stage: "",
      selected_sub_stage: "",
      callback_date: "",
      callback_time: "",
      lead_comment: "",
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     if (to.name === "adminDashboard") {
  //       vm.selectOption = "Leads_details";
  //       vm.commingSoon = true;
  //       const id = to.query.id;
  //       if (id) {
  //         vm.fetchLeadDetail(id);
  //       } else {
  //         console.warn("No ID provided for fetching lead details.");
  //       }
  //     }
  //   });
  // },

  mixins: [stateMixins, countryCodeMixins],
  computed: {
    ...mapGetters(["userInfo", "isAuthenticated"]),
  },
  components: {
    Navigation,
    Chart,
    circleChart,
    LeftNavigation,
    CampaignView,
    CampaignMapping,
    RecipientViewVue,
    EmailTemplate,
  },
  async created() {
    this.loader = true;
    await this.userCount();
    await this.userInfoGet();
    await this.leadDetailsFetch();
    this.slice_end = this.slice_limit;
    this.frontEnd = `${process.env.VUE_APP_SITE}`;
  },
  async mounted() {},
  methods: {
    async appliedUniversity() {
      await axios
        .get(`${process.env.VUE_APP_API}/selected-university/list/`)
        .then((resp) => {
          if (resp.status == 200) {
            this.select_val = "applied-university";
            this.appliedUniversityList = resp.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async leadDetailsFetch() {
      // let token = `${process.env.VUE_APP_TOKEN}`;
      // console.log("token 2367", token);
      await axios
        .get(
          `${process.env.VUE_APP_API}/enquire/list/?Key=${this.userInfo.data.token}`,
          {
            headers: {
              Authorization: `Token ${this.userInfo.data.token}`,
            },
          }
        )
        .then((resp) => {
          console.log("resp lead 1550", resp);
          if (resp.data.data.status == 200) {
            this.total_std_list = resp.data;
            this.lead_next = resp.data.next;
            this.lead_prev = resp.data.previous;
            this.current_page_number = resp.data.current_page_number;
            this.total_pages = resp.data.total_pages;
            this.leads = resp.data.data.data;
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          } else if (resp.data.data.status == 400) {
            setTimeout(() => {
              this.loader = false;
            }, 1000);
          }
        })
        .catch((error) => {
          console.error("Error fetching leads:", error);
        });
    },
    async nextLead() {
      await axios
        .get(`${this.lead_next}`)
        .then((resp) => {
          this.total_std_list = resp.data;
          this.leads = resp.data.data.data;
          this.lead_next = resp.data.next;
          this.lead_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          this.last_value = this.current_page_number * 20;
          this.total_pages = resp.data.total_pages;
          this.loader = false;
          if (this.lead_next === null) {
            this.last_value = resp.data.count;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // previous stduent list
    async prevLead() {
      await axios
        .get(`${this.lead_prev}`)
        .then((resp) => {
          this.total_std_list = resp.data;
          this.leads = resp.data.data.data;
          this.lead_next = resp.data.next;
          this.lead_prev = resp.data.previous;
          this.current_page_number = resp.data.current_page_number;
          this.total_pages = resp.data.total_pages;
          this.first_value = (this.current_page_number - 1) * 20 + 1;
          // this.last_value = (this.last_value / 20 - 1) * 20;
          this.loader = false;
          if (this.lead_next === null) {
            this.last_value = resp.data.count;
          } else {
            this.last_value = this.current_page_number * 20;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // filter leads
    searchLead() {
      console.log("entered searchLead method :::hjg");
      axios
        .get(
          `${process.env.VUE_APP_API}/enquire/list/?search=${this.lead_search}&Key=${this.userInfo.data.token}`,
          {
            headers: {
              Authorization: `Token ${this.userInfo.data.token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.leads = response.data.data;
          }
        })
        .catch((error) => {
          console.error("Error fetching leads:", error);
        });
    },
    // update lead stage
    UpdateLeadStage() {},
    // lead activity
    leadActivity() {},
    enrollmentPost() {
      let student_id = JSON.stringify(this.selectedUser.user.id);
      let bodyVal = {
        student: student_id,
        university_id: $("#universities").val(),
        elective_id: $("#elective").val(),
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/enrolment/post/?Key=${this.userInfo.data.token}`,
          bodyVal
        )
        .then((resp) => {
          console.log(resp);
          if (resp.data.status == 200) {
            $(".enrollPopup").show(1000);
            $(".Enroll_submit").append(
              `<p class="EnrollmentStatus py-4 text-sm font-medium text"> Student Enrolled successfully</p>`
            );
          } else {
            $(".Enroll_submit").append(
              `<p class="EnrollmentStatus py-4 text-sm font-medium text"> Student Enrolled Failed</p>`
            );
          }
          setTimeout(() => {
            $(".EnrollmentStatus").remove();
            $(".enrollPopup").hide(1000);
          }, 3000);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    popUpClose(el) {
      $(".enrollPopup").hide(1000);
    },
    enrollPopUp(userDetails) {
      this.selectedUser = userDetails;
      $(".enrollPopup").show(1000);
      this.universityCall();
      this.programCall();
    },
    async universityCall() {
      await axios
        .get(`${process.env.VUE_APP_API}/student/universities_all/list/`)
        .then((resp) => {
          if (resp.status == 200) {
            this.university_list = resp.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async programCall() {
      await axios
        .get(`${process.env.VUE_APP_API}/student/program_name/list/`)
        .then((resp) => {
          if (resp.status == 200) {
            this.program_list = resp.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    electiveCall() {
      let program_id = $("#program").val();
      let university_id = $("#universities").val();

      axios
        .get(
          `${
            process.env.VUE_APP_API
          }/student/universities/test/list/?university__id=${parseInt(
            university_id
          )}&program__id=${parseInt(program_id)}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.elective_list = resp.data.data;
          } else {
            this.elective_list = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    userFilterCall(el) {
      let selected_val = el.target.value;
      if (selected_val == "All Users") {
        this.userInfoGet();
      } else if (selected_val == "Direct Users") {
        this.verified_student();
      } else if (selected_val == "Raw Users") {
        this.raw_student();
      } else if (selected_val == "Exam details") {
        this.examResults();
      } else if (selected_val == "Applied elective") {
        this.applieduser();
      } else if (selected_val == "Download Brochure") {
        this.downloadBr();
      } else if (selected_val == "Channel Partner") {
        this.cpInfoGet();
      } else if (selected_val == "Applied university") {
        this.appliedUniversity();
      }
    },
    async cpInfoGet() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/staff_profile/?user__staff_profile__handler_type__name=cp_admin&Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.select_val = "cp";
            this.cpList = resp.data.data;
          } else {
            this.select_val = "cp";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async downloadBr() {
      await axios
        .get(`${process.env.VUE_APP_API}/selected-elective-brochure/list/`)
        .then((resp) => {
          if (resp.status == 200) {
            this.select_val = "downloadbr";
            this.downloadbrochure = resp.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async applieduser() {
      await axios
        .get(`${process.env.VUE_APP_API}/selected-elective/list/`)
        .then((resp) => {
          if (resp.status == 200) {
            this.select_val = "applied";
            this.appliedElectiveList = resp.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    dateFormat(el) {
      return convertdate.dateFormatDDMMYYYY(el);
    },
    async userInfoGet(page_no = 1) {
      this.select_val = "all_user";
      await axios
        .get(
          `${process.env.VUE_APP_API}/profile_all/?Permission_access=student&Key=${this.userInfo.data.token}&page=${page_no}`
        )
        .then((resp) => {
          this.selectUserStr = "All Users";
          this.userRegisterList = resp.data;
          this.total_pages = this.userRegisterList.total_pages;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async verified_student() {
      this.select_val = "all_user";
      await axios
        .get(
          `${process.env.VUE_APP_API}/profile_all/?Permission_access=student&lead_type=verified&Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          this.selectUserStr = "All verify Users";
          this.userRegisterList = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async raw_student() {
      this.select_val = "all_user";
      await axios
        .get(
          `${process.env.VUE_APP_API}/profile_all/?Permission_access=student&lead_type=raw&Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          this.selectUserStr = "All Raw Users";
          this.userRegisterList = resp.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async examResults() {
      await axios
        .get(`${process.env.VUE_APP_API}/reservation-booking/list/`)
        .then((resp) => {
          this.select_val = "exam_result";
          if (resp.data.status == 200) {
            this.examsResultsList = resp.data;
          } else {
            this.examsResultsList = "";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async userCount() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/student/exam/applied/count/list/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.userCountVal.allUser = resp.data.user.count;
            this.userCountVal.allUserVerified = resp.data.user.verified_user;
            this.userCountVal.exams_done =
              resp.data.exam_attended_details.count;
            this.userCountVal.students_applied_elective =
              resp.data.total_applied;
            this.userCountVal.downloadbrochure =
              resp.data.brochure_details.total_of_university_elective;
            this.userCountVal.enrollment = resp.data.enrolment;
            this.userCountVal.isData = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    fileUpload(el) {
      this.ld_btn = true;
      let bodyVal = new FormData();
      bodyVal.append("batchname", el.target.batch_name.value);
      bodyVal.append("my_file", el.target.fileUpload_csv.files[0]);
      axios
        .post(
          `${process.env.VUE_APP_API}/student/data_upload/?Key=${this.userInfo.data.token}`,
          bodyVal
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.message.text = "Data uploaded successfully";
            this.message.type = "success";
            this.ld_btn = false;
            this.$refs.fileUploadFiled.reset();
          } else {
            this.message.text = "check the fields";
            this.message.type = "error";
            this.ld_btn = false;
          }
        })
        .catch((error) => {
          this.message.text = "Server Error";
          this.message.type = "error";
          this.ld_btn = false;
        });
      setTimeout(() => {
        this.message.text = "";
        this.message.type = "";
      }, 7000);
    },
    selectPage(index) {
      this.current_position = index + this.slice_start;
      this.userInfoGet(this.current_position + 1);
    },
    closePopup() {
      this.addCampain = false;
    },
    // pagenation
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },

    // lead details

    async fetchLeadDetail(id) {
      this.lead_id = id;
      const leadId = id;
      console.log("leadId", leadId);
      await axios
        .get(
          `${process.env.VUE_APP_API}/enquire/list/?id=${leadId}&Key=${this.userInfo.data.token}`,
          {
            headers: {
              Authorization: `Token ${this.userInfo.data.token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            console.log("lead_details fetchlead 1924:", response.data.data);
            this.lead_details = response.data.data.data;
            this.getFolowUp();
            // (this.updatedName = this.leadDetails.name),
            //   (this.updatedEmail = this.leadDetails.email),
            //   (this.updatedPhoneNumber = this.leadDetails.phone_number),
            //   this.updatedSource,
            //   this.interestedProduct,
            //   this.lead_status,
            //   this.poc_name,
            //   this.poc_email,
            //   this.poc_phone,
            //   this.poc_role,
            console.log("this.leadDetails 1947", this.leadDetails);
            this.commingSoon = true;
          }
        })
        .catch((error) => {
          console.error("Error fetching lead details:", error);
        });
    },
    // get followup notes
    getFolowUp() {
      axios
        .get(
          `${process.env.VUE_APP_API}/leadfollowup-list/?Key=${this.userInfo.data.token}`
        )
        .then((resp) => {
          console.log("resp 2640", resp);
          if (resp.data.status == 200) {
            this.followup_list = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error ", err);
        });
    },

    // submit followup notes
    submitFollowup() {
      const followData = {
        title: this.followup_title,
        note: this.followup_note,
        lead: this.lead_id,
        user: this.userInfo.data.user.id,
      };
      console.log("this.userInfo.data.token", this.userInfo.data.token);
      axios
        .post(
          `${process.env.VUE_APP_API}/leadfollowup-create/post/?Key=${this.userInfo.data.token}`,
          followData
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.getFolowUp();
            this.isOffcanvasOpen = false;
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },

    setActiveComponent(componentName) {
      this.activeComponent = componentName;
    },
    openOffcanvas() {
      this.showOffcanvas = true;
    },
    closeOffcanvas() {
      this.showOffcanvas = false;
    },
    toggleOffcanvas() {
      this.isOffcanvasOpen = !this.isOffcanvasOpen;
    },
    closeOffNotes() {
      this.isOffcanvasOpen = false;
      this.title = "";
      this.noteContent = "";
    },
    toggleLeadEdit() {
      this.lead_activity_tog = !this.lead_activity_tog;
    },
    formatDate(dateString) {
      if (!dateString) return "Invalid Date";
      const date = new Date(dateString);

      const dateOptions = { month: "short", day: "2-digit", year: "numeric" };
      const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
        timeZone: "Asia/Kolkata",
      };

      const formattedDate = date.toLocaleDateString("en-IN", dateOptions);
      const formattedTime = date.toLocaleTimeString("en-IN", timeOptions);

      return `${formattedDate} / ${formattedTime}`;
    },
  },
};
</script>
<style scoped>
.selectOptions::after {
  content: "";
  position: absolute;
  bottom: -17px;
  right: 42%;
  z-index: 1;
  border-top: 27px solid #18469d;
  border-left: 17px solid transparent;
  border-right: 17px solid transparent;
}
/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 1s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.bulkUpload::after {
  content: "*";
  color: red;
}
</style>
